import {I18N_ENTITY_SUFFIX_MAPPING} from "../utils/constant";
import {store} from "../store/store";

export default function (item, prefix='label') {
  let i18nLabel = prefix + I18N_ENTITY_SUFFIX_MAPPING[store.getters['user/auth/locale']];
  return item[i18nLabel] ? item[i18nLabel] : item[prefix];
}



// WEBPACK FOOTER //
// ./src/filters/translateLabel.js